import { AppContext, AppContextProps } from '../AppContext';

type AppContext = {
    children: React.ReactNode;
    value: AppContextProps;
};

export const AppContextProvider = ({ children, value }: AppContext) => {
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
